import { render, staticRenderFns } from "./Unionmembers.vue?vue&type=template&id=4aa02522&"
import script from "./Unionmembers.vue?vue&type=script&lang=js&"
export * from "./Unionmembers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports